import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicReviews from "@/pages/PublicReviews";
import ReviewForm from "@/pages/ReviewForm";
import Guarantee from "@/pages/Guarantee";
import ClaimStatus from "@/pages/ClaimStatus";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Reviews from "@/pages/admin/Reviews";
import Invitations from "@/pages/admin/Invitations";
import Claims from "@/pages/admin/Claims";
import Integrations from "@/pages/admin/Integrations";
import Settings from "@/pages/admin/Settings";
import ImportReviews from "@/pages/admin/ImportReviews";
import Docs from "@/pages/admin/Docs";

const AuthScope = () => (<AuthProvider><Outlet /></AuthProvider>);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicReviews />} />
        <Route path="/recensione/:token" element={<ReviewForm />} />
        <Route path="/garanzia" element={<Guarantee />} />
        <Route path="/garanzia/stato" element={<ClaimStatus />} />
        <Route element={<AuthScope />}>
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="recensioni" element={<Reviews />} />
            <Route path="inviti" element={<Invitations />} />
            <Route path="garanzia" element={<Claims />} />
            <Route path="integrazioni" element={<Integrations />} />
            <Route path="impostazioni" element={<Settings />} />
            <Route path="importa" element={<ImportReviews />} />
            <Route path="documentazione" element={<Docs />} />
          </Route>
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
